import {React} from 'react';
import { Element } from 'react-scroll';
import { AnimatedTooltip } from "../../components/animated-tool-tip";
import { PlaceholdersAndVanishInput } from "../../components/vanish-and-input";


// https://videos.pexels.com/video-files/10507250/10507250-sd_426_240_25fps.mp4
const Feature1 = () => {

  const people = [
    {
      id: 1,
      name: "Amit Sharma",
      designation: "Travels to Himachal twice every quarter",
      image:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3387&q=80",
    },
    {
      id: 2,
      name: "Aniruddh P.",
      designation: "Enjoys beaches, more than mountains",
      image:
        "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 3,
      name: "Nadia",
      designation: "Likes to workation, more than vacation",
      image:
        "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YXZhdGFyfGVufDB8fDB8fHww&auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 4,
      name: "Anna S.",
      designation: "Building her next SaaS in god's own country",
      image:
        "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGF2YXRhcnxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&w=800&q=60",
    },
    {
      id: 5,
      name: "John Mark",
      designation: "On his first solo trip to Rajasthan",
      image:
        "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3540&q=80",
    },
    {
      id: 6,
      name: "Dora",
      designation: "Still bankrupt from her last foreign trip",
      image:
        "https://images.unsplash.com/photo-1544725176-7c40e5a71c5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3534&q=80",
    },
  ];

  const placeholders = [
    "What is the best time to visit Shimla",
    "Is it too cold in Laddakh during January",
    "What should I pack for a week in Gujarat"
  ];
  

  const handleChange = (e) => {
    console.log(e.target.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    console.log("submitted");
  };

  

  return (
    <Element name="component3" className="component">
      <div className="grid grid-cols-12 sm:grid-cols-12 lg:gap-4 sm:gap-0">
        <div className="lg:col-span-1 sm:col-span-12 p-2 flex items-center justify-center">
        </div>
        <div className="lg:col-span-4 sm:col-span-12 p-2 flex flex-col">
          <div className="flex flex-col lg:items-center lg:justify-center sm:justify-normal w-full lg:text-right sm:text-center">
            <div className="text-3xl text-custom-blue font-sans">
              Find your friends, colleagues and more
            </div>
            <div className='lg:block sm:hidden'>
            <div className="flex flex-row p-7">
              <AnimatedTooltip items={people} />
            </div> 
            </div>
            <div className="text-1_5xl text-custom-blue lg:pt-7 font-sans flex justify-center items-center">
              <div className='w-3/4'>
              Ask questions, post surveys, seek advice from your travel circle.
              </div>
            </div>
            <div className='lg:pt-7 lg:ml-7 sm:pt-3'>
              <PlaceholdersAndVanishInput placeholders={placeholders} onChange={handleChange} onSubmit={onSubmit} />
            </div>
            
          </div>
        </div>
        <div className="lg:col-span-6 sm:col-span-12 p-2  flex items-center justify-center">
          <img 
            src="https://images.unsplash.com/photo-1626231681172-0c54e184bea5?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            className="w-9/12 h-auto object-cover"/>
        </div>
        <div className="lg:col-span-1 sm:col-span-12 p-2 flex items-center justify-center">
        </div>
      </div>
    </Element>
  );
};

export default Feature1;